import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickFile from '@/components/brick_file.vue'
import SummaryFile from '@/components/summary_file.vue'
import Vue from 'vue'

Vue.component('SummaryFile', SummaryFile)

let infos = new BrickInfos()

infos.input = '   '
infos.back_classes = ['fas', 'fa-file', 'text-blue']
infos.front_classes = ['fas', 'fa-table', 'text-white']
infos.name = 'sourcefile'
infos.associated_class_name = 'AutomlFile'
infos.editing_component_name = 'BrickFile'
infos.editing_component = BrickFile
infos.summary_component_name = 'SummaryFile'
infos.summary_component = SummaryFile
infos.descriptions = {
  en: {
    short_tooltip_description: 'Source file',
    full_tooltip_description:
      'Source file (most commonly a CSV file) for which coercion and format detection can be tuned',
    navbar_name: 'Source file',
  },
  fr: {
    short_tooltip_description: 'Fichier source',
    full_tooltip_description:
      'Fichier source (le plus souvent un fichier .CSV) pour lequel les paramètres de coercion et de détection du format peuvent être configurés',
    navbar_name: 'Fichier source',
  },
}
// infos.short_tooltip_description = 'sourcefile_short_tooltip'
// infos.full_tooltip_description = 'sourcefile_full_tooltip'
// infos.navbar_name = 'sourcefile_navbar'
infos.background_color = 'blue'

brick_registerer(infos)
